module.exports = __webpack_public_path__ + "static/media/computer.6d7b0073.svg";